var path = '/app/components/navbar/menu-item.html';
var html = "<div ui-sref-active=active> <a ui-sref=decision-tree ng-click=$ctrl.parent.collapseNavbar()> <i class=\"fa fa-fw {{$ctrl.icon}}\"></i> <span>{{ $ctrl.text | translate }}</span> </a> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;